<template>
    <div class="detailPaper-view">
        <div v-if="cateName !== 'cateName'" class="detailPaper-view-header">
            <div class="crumbs-nav-mask">
                <p :style="{color: themeColor}" @click="goCateRoute('all')">
                    {{ langTransfer('全部分类') }}
                </p>
                <i :style="{background: themeColor}"/>
                <p :style="{color: themeColor}" @click="goCateRoute()">{{ cateName }}</p>
                <i :style="{background: themeColor}"/>
                <p :style="{color: themeColor}">{{ baseInfo.Name }}</p>
            </div>
        </div>
        <div ref="detailPaperBodyWrapper" class="detailPaper-body-wrapper">
            <div class="detailPaper-body">
                <div class="baseInfo-qrcode-mask">
                    <div class="baseInfo-mask">
                        <img :src="baseInfo.__cover"  class="cover-info"  v-if="resourceType === 'magazine' && baseInfo.CoverImages" :src2="baseInfo.CoverImages[2]" @error="$tools.nocover">
                        <img :src="baseInfo.__cover" class="cover-info" v-else>
                        <div class="text-infos">
                            <h5>{{ baseInfo.Name }}</h5>
                            <span>{{ baseInfo.__midInfo }}</span>
                            <div class="third-platform-shares">
                                <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                            </div>
                            <p v-html="baseInfo.__bottomInfo"></p>
                            <div class="actives">
                                <div class="goRead-btns-mask">
                                    <button v-show="baseInfo.ID"
                                            :disabled=" !isShowCatelogs"
                                            :style="{background: !isShowCatelogs ?
                                                         '#ccc' : themeColor,
                                                     cursor: !isShowCatelogs ? 'default' : ''}"
                                            class="text-reading"
                                            @click="goTextReading('')">
                                        {{ langTransfer('文本阅读') }}
                                    </button>
                                    <button v-show="baseInfo.ID"
                                            v-if="resourceType === 'magazine'"
                                            :disabled="!(baseInfo.__originalCount > 0)"
                                            :style="{color: baseInfo.__originalCount > 0 ? themeColor : '#ccc',
                                                     cursor: baseInfo.__originalCount > 0 ? '' : 'default',
                                                     borderColor: baseInfo.__originalCount > 0 ? themeColor : '#ccc'}"
                                            class="original-reading"
                                            @click="goOriginalReading">
                                        {{ langTransfer('原貌阅读') }}
                                    </button>
                                    <!-- <button v-if="resourceType === 'magazine' || resourceType === 'newspaper'" @click="gopast">
                                        <template v-if="resourceType === 'magazine'">
                                            过往期刊
                                        </template>
                                        <template v-if="resourceType === 'newspaper'">
                                            过往报纸
                                        </template>
                                    </button> -->
                                </div>
                                <button v-if="isNexus.includes('bookcaseoperation')"
                                        :style="{color: themeColor}"
                                        class="addto-bookCase"
                                        @click="bookCaseBtnClick">
                                    {{ bookCaseId === 0 || bookCaseId === undefined ?
                                    langTransfer('+ 加入书架') : langTransfer('- 移出书架') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="qrcode-mask">
                        <div ref="qrcode"
                                 class="qrcode">
                                 <img ref="qrcodeimag">
                        </div>
                        <p v-if="resourceType!=='newspaper'" :style="{fontSize: baseInfo.ShortCode ? '' : 0}">
                            {{ langTransfer('(微信)扫码免费借阅') }}
                        </p>
                        <p v-else>
                            {{ langTransfer('扫码免费借阅') }}
                        </p>
                    </div>
                </div>
                <div class="catelog-mask">
                    <div class="catelog-mask_left" :style="{width:isfullwidth ?'':'100%'}">                     
                            <div class="catelog-header">
                                <i :style="{background: themeColor}" class="warning-icon"/>
                                <h5  v-if="isShowCatelogs">
                                    {{ langTransfer('目录') }}
                                </h5>
                                 <h5 v-else>
                                    {{ langTransfer('内容预览') }}
                                </h5>
                            </div>
                            <div class="catelog-body" v-if="isShowCatelogs">
                                <div class="catelogfulllist"  v-for="(allitem,allindex) in catelogList">
                                    
                                    <div class="column" v-if="allitem.Column||allitem.ColumnName">
                                        <h5 :style="{color: themeColor}">
                                        {{ langTransfer(allitem.Column||allitem.ColumnName) }}
                                        </h5>
                                        <i :style="{background: themeColor}" class="warning-icon"/>
                                    </div>
                                    <div v-for="(item,index) in allitem.Articles"
                                         :key="index"
                                         class="catelog-item"
                                         @click="goTextReading(item)" :style="{width:resourceType=='book'?'100%':'94%'}">
                                        <h5>{{item.Title.replace(/<\/?.+?>/g,"")}}</h5>
                                        <div v-if="item.FirstImg || item.Summary" class="item-infos-mask">
                                            <img v-if="item.FirstImg" :src="item.FirstImg">
                                            <p>{{ item.Summary }}</p>
                                        </div>
                                    </div>
                                </div>                           
                            </div>
                            <div class="catelog-body catelog-body-img" v-else>
                                <div v-for="(i,d) in (Math.floor(originallist.length/2)>24?24:Math.floor(originallist.length/2))" class="catelog-img" @click="goOriginalReading(i)">
                                    <img :src="item" v-for="(item,index) in originallist.slice(d*2,d*2+2)"/>
                                </div>
                                <div class="catelog-img"  v-for="i in completedFlex(linecount,(Math.floor(originallist.length/2)>24?24:Math.floor(originallist.length/2)))"></div>
                            </div>
                    </div>
                    <div class="catelog-mask_right" v-if="isfullwidth">
                        <div class="catelog-mask_right_pastlist" v-if="pastMagazines.length>0">
                            <div class="catelog-header pastheader">
                                <div>
                                    <h5 :style="{color:themeColor}">
                                      {{ langTransfer('过往期刊') }}
                                    </h5>                                   
                                </div>
                                <div @click="goPast">
                                    更多
                                </div>
                            </div>                      
                            <div class="pastMagazine-mask">
                                <div class="pastMagazine-body">
                                    <div v-for="(item,index) in pastMagazines">
                                        <img :src="item.__cover" @click="goDetail(item)"/>
                                        <h5 @click="goDetail(item)">{{ item.Name }}</h5>
                                        <span @click="goDetail(item)">{{ item.__midInfo }}</span>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                        <div class="catelog-mask_right_pastlist"  v-if="userLikeList.length>0">
                            <div class="catelog-header pastheader">
                                <div>
                                    <h5 :style="{color:themeColor}">
                                      {{ langTransfer('猜你喜欢') }}
                                    </h5>                                   
                                </div>
                            </div>                      
                            <div class="pastMagazine-mask">
                                <div class="pastMagazine-body">
                                    <div v-for="(item,index) in userLikeList">
                                        <img :src="item.__cover" @click="goDetail(item)"/>
                                        <h5 @click="goDetail(item)">{{ item.Name }}</h5>
                                        <span @click="goDetail(item)">{{ item.__midInfo }}</span>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
                <div style="width: 100%;height: 20px;"/>
                <div class="site-footer">
                    <Footer/>
                </div>
            </div>
        </div>
        <backBtn/>
        <goTopBtn/>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import QRCode from 'qrcodejs2'
    import backBtn from '@/components/backBtn'
    import goTopBtn from '@/components/gotopBtn'
    import Footer from '@/components/footer'
    export default {
        components: {
            backBtn,Footer,goTopBtn
        },
        data () {
            return {
                detailPaperBScroll: null,
                resourceType: '',
                baseInfo: {},
                catelogList: [],
                postNewspapers:[],
                cateName: 'cateName',
                userLikeList: [],
                lastParams: {},
                bookCaseId: undefined,
                isPending: true,
                pastMagazines:[],
                isfullwidth:false,
                isShowCatelogs:false,
                originallist:[],
                linecount:3
            }
        },
        computed: {
            themeColor () {
                return this.$store.state.themeColor
            },
            isNexus () {
                return this.$store.state.isNexus
            }
        },
        activated () {
        },
        mounted () {
            //this.initBScroll()
        },

        methods: {
            goOriginalReading (index) {
                const {ID:id,Year:year,Issue:issue} = this.baseInfo
                let u = `https://${window.location.host}/OriginalReaderHtml/magazine/reader.html?id=${id}&year=${year}&issue=${issue}`;
                u+=`&templatename=weblibrary&virtualpath=${sessionStorage.getItem("virtualPath")}`;
                if('[object Number]'==Object.prototype.toString.call(index)){
                            u+=`#book7/page${index*2}-page${index*2+1}`
                }
                window.open(u, '_blank');
                // const { baseInfo } = this
                // const params = {
                //     id: baseInfo.ID,
                //     year: baseInfo.Year,
                //     issue: baseInfo.Issue,
                //     count: baseInfo.__originalCount
                // }
                // let routeUrl = this.$router.resolve({
                //     name: 'magazineOriginalReading',
                //     params
                //  });
                //  window.open(routeUrl .href, '_blank');


            },
            completedFlex(_size,_count)
            {
                //debugger
                let v= _count%_size;
                if(v)
                {
                    return _size-v;
                }
                return 0;
            },
            gopast()
            {
               window.location.href = "#pastreousce";
            },
            async getLatestMagazineInfo(){
                let {id} = this.$route.params
                let {Data}  = await this.$apis('magazine').getLatestMagazineInfo(id);
                return Data;     
            },
            goPast()
            {
                if (this.$route.params.resourceType === 'magazine')
                {
                    this.goPastMagazines()
                }
                if (this.$route.params.resourceType  === 'newspaper')
                {
                    this.goPastNewspapers();
                }
            },
            initBScroll () {
                this.$nextTick(() => {
                    this.detailPaperBScroll = new BScroll(this.$refs.detailPaperBodyWrapper, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                })
            },
            initQrCode (text) {
                const ele = this.$refs.qrcode
                ele.innerHTML = ''
                this.qrcode = new QRCode(ele, {
                    width: 222,
                    height: 222,
                    text
                })
            },
            async getShortQCUrl (shortCode) {
                try {
                    //let userInfos = this.$cookies.get('user');
                    let {Data} = await this.$apis('user').getuserisauthorized();
                    if (!Data) {
                        this.$refs.qrcodeimag.src=require('@/assets/defaultqrcode.png');
                        this.$refs.qrcode.className="qrcode qrocdenologin"
                        return;
                    }
                    const data = await this.$apis('shortQC').getShortQCUrl(shortCode)
                    if (data) {
                        this.initQrCode(data)
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getNewspaperQrUrl(id,year)
            {
                try {
                    let {Data} = await this.$apis('user').getuserisauthorized();
                    if (!Data) {
                        this.$refs.qrcodeimag.src=require('@/assets/defaultqrcode.png');
                        this.$refs.qrcode.className="qrcode qrocdenologin"
                        return;
                    }
                    const data = await this.$apis('shortQC').getNewspaperQrUrl(id,year)          
                    this.initQrCode(data)
                } catch (error) {
                    console.log(error)
                }
            },
            async getDetailInfo (params) {

                const {
                    resourceType, id, year, issue
                } = params
                let { Data } = await this.$apis(resourceType).getDetailInfo(id, year, issue)
                const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`;
                [Data] = this.$tools[toolFnName]([Data], '-z')
                if (resourceType === 'magazine') {
                    const __item = Data.Types ? Data.Types.find((e) => {
                        return e.MagazineType === 3
                    }) : undefined
                    Data.__originalCount = __item ? __item.PageCount : undefined
                }
                if (resourceType === 'magazine' && Data.Types) {

                    for (let i = 0; i < Data.Types.length; i++) {
                        if(Data.Types[i].MagazineType==2){
                            this.isShowCatelogs = true;
                            break;
                        }
                    }
                    
                }
                if (resourceType === 'book' && Data.Types) {
                    for (let i = 0; i < Data.Types.length; i++) {
                        if(Data.Types[i].BookType==1){
                            this.isShowCatelogs = true;
                            break;
                        }
                    }
                }
                if (resourceType === 'newspaper') {
                     this.isShowCatelogs = true;
                }
                this.baseInfo = Data
                this.isInUserBookCase();

                if(!this.isShowCatelogs &&  resourceType === 'magazine')
                {
                    let OriginalData = await this.$apis('magazine')
                            .getOriginalCatelog(id, year, issue, Data.__originalCount);
                    if(OriginalData.Data)
                    {
                        this.originallist = OriginalData.Data.slice(1);
                    }
                }


                this.$nextTick(() => {
                    // if(resourceType==='newspaper')
                    //     this.getNewspaperQrUrl(id,year);
                    // else
                        this.getShortQCUrl(Data.ShortCode)
                })
            },
            async getDetailCatelog (params) {
                try {
                    this.isPending = true
                    let {
                        resourceType, id, year, issue
                    } = params;
                    const { Data } = await this.$apis(resourceType).getCatelog(id, year, issue)
                    this.isPending = false
                    if (!Data) {
                        this.catelogList = undefined
                        return
                    }
                    if (resourceType === 'magazine' || resourceType === 'newspaper') {
                        // Data.forEach((e) => {
                        //     if (e.Articles.length > 0) {
                        //         e.Articles.forEach((child) => {
                        //             this.catelogList.push(child)
                        //         })
                        //     } else {
                        //         if (resourceType === 'magazine'){
                        //             this.catelogList.push(e)
                        //         }
                        //     }
                        // })
                        this.catelogList = Data;
                    }else {
                        this.catelogList = [{Articles:Data}];
                    }
                } catch (error) {
                    this.isPending = false
                    console.log(error)
                }
            },
            async getPastMagazines (params) {
                try {
                    const {
                        id, year, issue
                    } = params
                    const { Data } = await this.$apis('magazine').getPastMagazines(id)
                    let __arr = [];

                    /*Data.filter((e) => {
                        return e.Year == parseInt(year) && e.Issue !== parseInt(issue)
                    }).slice(0, 6)*/

                    for (var i = 0; i < Data.length; i++) {
                        if(Data[i].Year == parseInt(year) && Data[i].Issue== parseInt(issue)){
                            continue;
                        }
                        __arr.push(Data[i]);
                    }
                    this.pastMagazines = this.$tools.formatMagazineData(__arr.slice(0, 6))
                } catch (error) {
                    console.log(error)
                }
            },
            async getPastNewspaper(params)
            {
                try {
                    const {
                        id, year
                    } = params;
                    const { Data } = await this.$apis('newspaper').getPastNewspaper(id,new Date(year).getFullYear());
                    const __arr = Data.filter((e) => {
                        return (new Date(e.PubDate)).getFullYear() == (new Date(year)).getFullYear()  && e.PubDate!=year

                    }).slice(0, 6)
                    this.pastMagazines = this.$tools.formatNewspaperData(__arr)
                } catch (error) {
                    console.log(error)
                }
            },
            async getUserLike (params,_cateCode) {
                try {
                    const {
                        resourceType, id, cateCode
                    } = params
                    const pageSize = 7
                    const pageIndex = 1
                    const { Data } = await this.$apis(resourceType)
                        .getListByCate(_cateCode?_cateCode:cateCode, pageIndex, pageSize)
                    const __arr = Data.filter((e) => {
                        return e.ID !== id
                    }).slice(0, 6)
                    const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`
                    this.userLikeList = this.$tools[toolFnName](__arr)
                } catch (error) {
                    console.log(error)
                }
            },
            goDetail (item) {
                const { resourceType } = this
                const { cateCode, cateName } = this.$route.params
                let cate
                if (cateCode !== 'cateCode' && cateName !== 'cateName') {
                    cate = {
                        CategoryCode: cateCode,
                        CategoryName: cateName
                    }
                }
                this.$tools.goDetailRoute.call(this, resourceType, item, cate)
            },
            goPastMagazines () {
                const { id, cateName } = this.$route.params
                this.$router.push({
                    name: 'pastMagazine',
                    params: {
                        id,
                        cateName
                    }
                })
            },
            goPastNewspapers()
            {
                const { id } = this.$route.params
                let date = new Date(this.$route.params.year);

                this.$router.push({
                    name: 'pastNewspaper',
                    params: {
                       id,
                       year:date.getFullYear(),
                       month:date.getMonth()
                    }
                })
            },
            goTextReading (item) {
                const { resourceType, catelogList } = this
                const { id, year, issue } = this.$route.params;
                let changeaid =false; 
                if(!item){
                    changeaid= true;
                }
                item = item || catelogList[0];

                let params = {
                    resourceType,
                    id,
                    year,
                    issue,
                    articleId: item.ArticleID,
                    token:'token'
                }
                if(changeaid){
                    params.articleId = item.Articles[0].ArticleID
                }

                if (resourceType === 'book') {
                    params.guid = id
                }
                this.$router.push({
                    name: 'textReading',
                    params
                })
            },
            bookCaseBtnClick () {
                let userInfos
                try {
                    userInfos = this.$cookies.get('user')
                } catch (error) {
                    console.log(error)
                }
                if (!userInfos) {
                    this.$store.commit('setShowLoginRegister', true)
                    return
                }
                const { bookCaseId } = this
                if (bookCaseId !== 0) {
                    this.removeFromBookCase()
                } else {
                    this.addToBookCase()
                }
            },
            async addToBookCase () {
                try {
                    this.bookCaseId = undefined
                    const {
                        resourceType, id, year, issue
                    } = this.$route.params
                    const formData = {
                        resourceid: id
                    }
                    if (resourceType === 'magazine') {
                        formData.resourcekind = 2
                        formData.year = year
                        formData.issue = issue
                    } 
                    else if(resourceType === 'newspaper')
                    {
                        formData.resourcekind = 7
                        formData.date = year
                    }
                    else{
                        formData.resourcekind = 3
                    }
                    const data = await this.$apis('user').addToBookCase(formData)
                    if (data.Code === 1) {
                        this.bookCaseId = data.Data
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async removeFromBookCase () {
                try {
                    this.bookCaseId = undefined
                    const {
                        resourceType, id, year, issue
                    } = this.$route.params
                    const formData = {
                        resourceid: id
                    }
                    if (resourceType === 'magazine') {
                        formData.resourcekind = 2
                        formData.year = year
                        formData.issue = issue
                    } 
                    else if(resourceType === 'newspaper')
                    {
                        formData.resourcekind = 7
                        formData.date = year
                    }
                    else{
                        formData.resourcekind = 3
                    }
                    const data = await this.$apis('user').removeFromBookCase(formData)
                    if (data.Code === 1) {
                        this.bookCaseId = 0
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async isInUserBookCase () {
                try {
                    const { userInfos } = this.$store.state
                    if (!userInfos) {
                        return
                    }
                    const {
                        resourceType, id, year, issue
                    } = this.$route.params
                    const res = {
                        resourceid: id
                    }
                    if (resourceType === 'magazine') {
                        res.year = year
                        res.issue = issue
                    }
                    if (resourceType === 'newspaper') {
                        res.date = year;
                        res.kind = 7;
                    }
                    const { Data } = await this.$apis('user').isInUserBookCase(res)
                    this.bookCaseId = Data
                } catch (error) {
                    console.log(error)
                }
            },
            goCateRoute (all) {
                const {
                    resourceType, cateCode
                } = this.$route.params
                const params = {
                    resourceType
                }
                params.cateCode = all ? 'all' : cateCode

                this.$router.push({
                    name: 'allCates',
                    params
                })
            },
            getResouceCode(params)
            {   
                const {
                    resourceType, id, year, issue
                } = params 
                let _resoucelist = this.$store.state.allresoucelist;
                return new Promise(async (a,b)=>{
                    let retcode = 'cateCode';
                    if(_resoucelist.length<=0)
                    {
                        _resoucelist = (await this.$apis('user').getallresourecelist()).Data;
                        this.$store.commit('setAllResouceList',_resoucelist.Data);
                    }                   
                    for (let i = 0; i < _resoucelist.length; i++) 
                    {
                        if(_resoucelist[i].ID.toLowerCase()==id.toLowerCase()){
                            retcode = _resoucelist[i].Code;
                            break;
                        }
                    }
                    a(retcode);                    
                })
            }
        },
        beforeRouteUpdate (to, from, next) {
            const {
                resourceType, cateCode, cateName
            } = to.params
            this.resourceType = resourceType
            this.baseInfo = {}
            this.catelogList = []
            this.pastMagazines = []
            this.userLikeList = []
            this.bookCaseId = undefined
            this.cateName = cateName;
            this.isfullwidth = false;
            this.isShowCatelogs = false;
            if (this.detailPaperBScroll) {
                this.detailPaperBScroll.refresh()
                this.detailPaperBScroll.scrollTo(0, 0)
            }
            this.getDetailInfo(to.params)
            this.getDetailCatelog(to.params)
            if (resourceType === 'magazine') {
                this.getPastMagazines(to.params);
                this.isfullwidth = true;
            }
            if (resourceType === 'newspaper') {
                this.getPastNewspaper(to.params);
                this.isfullwidth = true;
            }
            if (cateCode !== 'cateCode') {
                this.getUserLike(to.params);
                this.isfullwidth = true;
            }else{
                (async ()=>{
                    let _cateCode = await  this.getResouceCode(to.params);
                    this.getUserLike(to.params,_cateCode);
                    this.isfullwidth = true;
                })()
            }
            next()
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                let { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    //return
                }
                let {
                    resourceType, cateCode, cateName
                } = params
                vm.lastParams = params
                vm.resourceType = resourceType
                vm.baseInfo = {}
                vm.catelogList = []
                vm.pastMagazines = []
                vm.userLikeList = []
                vm.bookCaseId = undefined
                vm.cateName = cateName
                vm.isShowCatelogs = false;
                vm.isfullwidth = false;
                if (vm.detailPaperBScroll) {
                    vm.detailPaperBScroll.refresh()
                    vm.detailPaperBScroll.scrollTo(0, 0)
                }
                (async ()=>{
                    if(resourceType === 'magazine' && params.year==='magazine')
                    {
                        let defaultdata = await vm.getLatestMagazineInfo();
                        params.year = defaultdata.Year;
                        params.issue = defaultdata.Issue;
                    }
                    vm.getDetailInfo(params)
                    vm.getDetailCatelog(params)
                    if (resourceType === 'magazine') {
                        vm.getPastMagazines(params);
                        vm.isfullwidth = true;
                    }
                    if (resourceType === 'newspaper') {
                        vm.getPastNewspaper(params);
                        vm.isfullwidth = true;
                    }
                    if (cateCode !== 'cateCode') {
                        vm.getUserLike(params);
                        vm.isfullwidth = true;
                    }else{
                        let _cateCode = await  vm.getResouceCode(params);
                        vm.getUserLike(params,_cateCode);
                        vm.isfullwidth = true;
                    }
                })();
            })
        }
    }
</script>

<style lang="scss" scoped>
    .detailPaper-view {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
    }

    .detailPaper-view-header {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        background: #F6FAFF;
    }

    .crumbs-nav-mask {
        width: 1140px;
        height: 40px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
            
            font-size: 13px;
            color: #4BA8FF;
            letter-spacing: 0;
            cursor: pointer;
        }

        i {
            width: 1px;
            height: 12px;
            display: block;
            transform: rotate(20deg);
            background: #4BA8FF;
            border-radius: 100px;
            margin: 0 10px;
        }
    }

    .detailPaper-body-wrapper {
        width: 1140px;
        position: absolute;
        top: 40px;
        bottom: 0;
        left: 50%;
        right: 0;
        margin-left: -570px;
        //overflow: hidden;
    }

    .detailPaper-body {
        width: 100%;
        padding-bottom: 138px;
    }

    .baseInfo-qrcode-mask {
        width: 1140px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .baseInfo-mask {
        width: 850px;
        height: 368px;
        box-sizing: border-box;
        padding: 32px 34px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .cover-info {
        width: 240px;
        height: 304px;
        border-radius: 4px;
        box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
        background: #f6f6f6;
    }

    .text-infos {
        width: 518px;
        height: 304px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        h5 {
            
            font-size: 24px;
            color: #1A1A1A;
            line-height: 24px;
        }

        span {
            
            font-size: 16px;
            color: #8590A6;
            line-height: 16px;
            margin: 16px 0 24px;
        }

        .third-platform-shares {
            height: 36px;
            padding-left: 2px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            opacity: 0;

            img {
                width: 28px;
                height: 28px;
                margin-right: 7px;
                border-radius: 50%;
            }
        }

        p {
            height: 100px;
            
            font-size: 14px;
            color: #79808B;
            letter-spacing: 0;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            margin: 16px 0 24px;
        }

        .actives {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .goRead-btns-mask {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            button {
                width: 120px;
                height: 34px;
                border-radius: 2px;
                
                font-size: 14px;
                letter-spacing: 0;
                text-align: center;
                line-height: 14px;
            }
        }

        .text-reading {
            color: #fff;
            margin-right: 15px;
            background: #4BA8FF;
        }

        .original-reading {
            background: #FFFFFF;
            color: #0084FF;
            border-width: 1px;
            border-style: solid;
            border-color: #4BA8FF;
        }

        .addto-bookCase {
            
            font-size: 14px;
            color: #0084FF;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
        }
    }

    .qrcode-mask {
        width: 270px;
        height: 368px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .qrcode {
            width: 222px;
            height: 222px;
            //background: #f6f6f6;
        }
        .qrocdenologin{
            border: 1px solid #e9e9e9;
            padding: 6px;
            box-sizing: content-box;
        }

        p {
            
            font-size: 14px;
            color: #79808B;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            margin-top: 40px;
        }
    }

    .catelog-mask {
        width: 1140px;
        
        
        border-radius: 2px;
        margin-top: 20px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: start;
        &>.catelog-mask_left{
            width: 850px;
            background: #FFFFFF;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
            .catelog-body-img{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
            }
            .catelog-item:not(:first-child)
            {
                padding: 20px 0;
            }
            .catelog-img:empty{
                    border: unset !important;
                }
            .catelog-img{
                width: 240px;
                height: 153px;
                margin-bottom:7px;
                cursor: pointer;
                border: 1px solid #e7e7e7;
                cursor:pointer;
                img{                   
                    height: 100%;
                    width: 120px;
                }   
            }
        }
        &>.catelog-mask_right{
            width: 270px;


            &>div{
                width: 100%;            
                background: #FFFFFF;
                box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
                .pastheader{ 
                    padding: 0 10px !important; 
                    display: flex;
                    justify-content: center;
                    background-color:unset !important;
                    &>div:first-child{
                        flex:1;
                        display: flex;
                        flex-wrap: nowrap;
                        justify-content: start;
                    }
                    &>div:last-child{
                        width: 50px;
                        text-align: right;
                        font-size: 14px;
                        color: #c1c1c1;
                        cursor:pointer;
                    }
                    h5{
                        cursor: pointer;
                        margin-right: 10px;
                        line-height: 30px !important;
                    }
                }
                .pastMagazine-mask {
                    width: 100%;
                    background: #FFFFFF;
                     margin-top: unset !important;
                    .catelog-header {
                        display: flex;
                        flex-direction: row;
                        justify-content:space-between;
                        align-items: center;
                    }

                    .header-text {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                    }
                }
                .pastMagazine-body {
                    width: 100%;
                    box-sizing: border-box;
                    padding:10px 10px 0 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    
                    flex-wrap: wrap;

                    &>div{
                        width: 120px;
                        cursor:pointer;
                        margin-bottom: 10px;
                        &>img{
                            width: 100%;
                            height: 153px;
                        }
                        h5 {
                            
                            font-size: 16px;
                            color: #1A1A1A;
                            line-height: 22px;
                            margin: 8px 0;
                            cursor: pointer;
                        }

                        span {
                            display: block;
                            
                            font-size: 14px;
                            color: #8590A6;
                            line-height: 14px;
                            cursor: pointer;
                        }
                    }
                }                
            }
            &>div:first-child{
                margin-bottom: 20px;
            }
        }
    }

    .catelog-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
        }

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            margin-right: 8px;
            background: #0084FF;
            border-radius: 2px;
        }
    }

    .catelog-body {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 34px;

        &>.catelogfulllist{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: end;
            &>.column{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                h5 {
                    
                    font-size: 20px;
                    line-height: 50px;
                }

                .warning-icon {
                    display: block;
                    width: 4px;
                    height: 16px;
                    margin-left: 8px;
                    background: #0084FF;
                    border-radius: 2px;
                }            
            }            
        }

    }

    .catelog-item {
        width: 94%;
        padding: 15px 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        //align-items: center;
        border-bottom: 1px solid #F0F2F7;
        cursor: pointer;

        h5 {
            width: 100%;
            
            font-size: 18px;
            color: #1A1A1A;
            letter-spacing: 0;
            line-height: 20px;
            margin-bottom: 10px;
        }

        .item-infos-mask {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            img {
                width: 104px;
                height: 64px;
                display: block;
                margin-right: 8px;
            }

            p {
                flex: 1;
                
                font-size: 14px;
                color: #79808B;
                letter-spacing: 0;
                text-align: justify;
                max-height: 60px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }
    }

    .catelog-item:hover {
        background: #F6F6F6;
    }

    .catelog-item:last-child {
        border-bottom: none;
    }

    .pastMagazine-mask {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        margin-top: 20px;

        .catelog-header {
            display: flex;
            flex-direction: row;
            justify-content:space-between;
            align-items: center;
        }

        .header-text {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }


        // p {
        //     width: 42px;
        //     
        //     font-size: 14px;
        //     color: #8590A6;
        //     line-height: 50px;
        //     background-image: url("../../assets/homeRecommend/right-arrow.png");
        //     background-repeat: no-repeat;
        //     background-position: right center;
        //     background-size: 6px 12px;
        //     cursor: pointer;
        // }
    }

    // .pastMagazine-body {
    //     width: 100%;
    //     box-sizing: border-box;
    //     padding: 16px 34px;
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: space-between;
    //     //align-items: center;
    // }

    .pastMagazine-item {
        width: 150px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        img {
            width: 150px;
            height: 190px;
            display: block;
            border-radius: 4px;
            cursor: pointer;
            box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
            background: #f6f6f6;
        }

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 22px;
            margin: 14px 0 8px;
            cursor: pointer;
        }

        span {
            display: block;
            
            font-size: 14px;
            color: #8590A6;
            line-height: 14px;
            cursor: pointer;
        }
    }

    .site-footer {
        position: relative;
        bottom: 0;
        left: 0;
        border-top: none;
    }

    .loader {
        width: 100%;
        height: 90px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>
